import React, { useEffect } from 'react';
import { TopBanner } from '../components/TopBanner';
import { HeroSection } from '../components/HeroSection';
import { QuickTestimonials } from '../components/QuickTestimonials';
import { BenefitsBullets } from '../components/BenefitsBullets';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttemptsSection } from '../components/FailedAttemptsSection';
import { MidPageCTA } from '../components/MidPageCTA';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeBlock } from '../components/GuaranteeBlock';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-maternal-cream font-body text-maternal-brown overflow-x-hidden pt-8" data-id="element-296">
      <TopBanner data-id="element-297" />

      {/* 1. HERO + CTA (top) */}
      <HeroSection data-id="element-298" />

      {/* 2. Social proof early — before first scroll */}
      <QuickTestimonials data-id="element-299" />

      {/* 3. Quick-scan benefits */}
      <BenefitsBullets data-id="element-300" />

      {/* 4. Emotional hook — shorter before CTA */}
      <OpeningHookSection data-id="element-301" />
      <ProblemSection data-id="element-302" />
      <FailedAttemptsSection data-id="element-303" />

      {/* 5. MID-PAGE CTA */}
      <MidPageCTA data-id="element-304" />

      {/* 6. Solution & details */}
      <MechanismSection data-id="element-305" />
      <WhatYouGetSection data-id="element-306" />
      <WhoIsForSection data-id="element-307" />
      <HowItWorksSection data-id="element-308" />

      {/* 7. Full testimonials */}
      <TestimonialsSection data-id="element-309" />

      {/* 8. Guarantee */}
      <GuaranteeBlock data-id="element-310" />

      {/* 9. FAQ */}
      <FAQSection data-id="element-311" />

      {/* 10. FINAL CTA + OFFER (bottom) */}
      <OfferSection data-id="element-312" />

      <Footer data-id="element-313" />
      <PurchaseNotifications data-id="element-314" />
    </div>;
}